module.exports = __webpack_public_path__ + "static/media/shootfy.7451e798.webp";